import { Component, Input } from '@angular/core';
import { MonitoringKeywordGroupModel } from '../../models/monitoring-keyword-group.model';
import { MediaSubscriptionKeywordsModel } from '../../models/media-subscription-keywords.model';

@Component({
    selector: 'agpr-keyword-group-summary',
    templateUrl: './keyword-group-summary.component.html',
    styleUrls: ['./keyword-group-summary.component.scss'],
    standalone: false
})
export class KeywordGroupSummaryComponent {
    @Input() keywordGroup: MonitoringKeywordGroupModel | MediaSubscriptionKeywordsModel;
    @Input() styleClass: string | Object;
}
